import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {SeparatorComponent} from '@/app/shared/components/separator/separator.component';
import {Ambassador} from '@/app/core/models/ambassador';
import {AmbassadorService} from '@services/ambassador.service';
import {AmbassadorCardComponent} from '@components/ambassador-card/ambassador-card.component';
import {Title} from '@angular/platform-browser';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';

@Component({
	selector: 'app-ambassadors',
	imports: [
		SeparatorComponent,
		AmbassadorCardComponent,
		TranslatePipe,
		LastVideosComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './ambassadors.component.html',
})
export class AmbassadorsComponent implements OnInit {

	  constructor(
		private readonly ambassadorService: AmbassadorService,
		private readonly titleService: Title,
		protected readonly translate: TranslateService
	  ) {}

	@ViewChild('slider') sliderRef!: ElementRef;

	ambassadors: Ambassador[] = [];

	private touchStartX = 0;
	private touchEndX = 0;
	private swipeThreshold = 50;

	ngOnInit(): void {
		this.loadAmbassadors();
	}

	loadAmbassadors(): void {
		this.ambassadorService.getAllAmbassadors().subscribe({
			next: (ambassadors) => {
				this.ambassadors = ambassadors;
			},
			error: (error) => {
				console.error('Error fetching ambassadors:', error);
			}
		});
	}

	scrollSlider(direction: 1 | -1) {
		const slider = this.sliderRef.nativeElement as HTMLElement;

		const cardWidth = slider.querySelector('div')?.clientWidth ?? 300;
		const gap = 16;
		const scrollAmount = cardWidth + gap;

		slider.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
	}

	onTouchStart(event: TouchEvent) {
		this.touchStartX = event.touches[0].clientX;
	}

	onTouchMove(event: TouchEvent) {
		this.touchEndX = event.touches[0].clientX;
	}

	onTouchEnd() {
		const distance = this.touchEndX - this.touchStartX;

		if (distance > this.swipeThreshold) {
			this.scrollSlider(-1);
		} else if (distance < -this.swipeThreshold) {
			this.scrollSlider(1);
		}

		this.touchStartX = 0;
		this.touchEndX = 0;
	}

}
